import styled from 'styled-components/macro';
import { TabHeader } from 'src/components/molecules/MultiTab/MultiTab';

export const StyledTabHeader = styled(TabHeader)`
  margin: 0rem !important;
  border-bottom: ${({ theme }) => `1px solid ${theme.color.gray[200]}`};
  padding-inline-start: 0;
`;
